import React, {Component, Fragment} from "react";
import axios from "axios";
import Titre from "../../../components/UI/Titres/TitreH1";
import Button from "react-bootstrap/Button";
import Boutton from "../../../components/UI/Bouton/Bouton";
import Etablissement78 from "./Etablissement78/Etablissement78";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

class Localisation extends Component {
    state = {
        recherche :[],
        numeroPageActuel : 1
    }

    rechercheEtablissement = (type)=>{
        axios.get(`https://etablissements-publics.api.gouv.fr/v3/departements/78/${type}`)
            .then(response =>{
                console.log(response.data);
                this.setState({
                    recherche:response.data.features, 
                    numeroPageActuel : 1
                });
            })
    }

    render() {
        let pagination =[];
        let recherche="";
        if(this.state.recherche){
            let fin = this.state.recherche.length/10;
            if(this.state.recherche.length %10 !==0) fin++;
            for (let i=1; i<=fin ;i++){
                pagination.push(
                    <Boutton 
                    key={i} 
                    typeBtn="btn-info" 
                    //estSelection={this.numeroPageActuel===i}
                    clic={()=>this.setState({numeroPageActuel:i})}
                    >{i}</Boutton>
                    
                );
            }
            const debut =(this.state.numeroPageActuel-1)*10;
            const finListe =(this.state.numeroPageActuel-1)*10 +10;
            const rechercheReduite= this.state.recherche.slice(debut,finListe)
            recherche=rechercheReduite && rechercheReduite.map(etablissement =>{
                    return (
                        <Col md={6} key={etablissement.properties.id}>
                            <Etablissement78
                                adresses = {etablissement.properties.adresses}
                                horaires = {etablissement.properties.horaires}
                                id = {etablissement.properties.id}
                                nom = {etablissement.properties.nom}
                                mail = {etablissement.properties.email}
                                telephone = {etablissement.properties.telephone}
                                url = {etablissement.properties.url}
                                    
                            />
                        </Col>    
                    );
            })
            
        }
        return (
            
            <Fragment>
                 <Titre>Recherchez un établissement  </Titre>
                 <Button variant="secondary" onClick ={()=>this.rechercheEtablissement('mairie')}>Mairie</Button>                
                 <Button variant="secondary" onClick ={()=>this.rechercheEtablissement('pole_emploi')}>Pôle emploi</Button>
                 <Button variant="secondary" onClick ={()=>this.rechercheEtablissement('caf')}>C.A.F</Button>
                 <Button variant="secondary" onClick ={()=>this.rechercheEtablissement('cpam')}>C.P.A.M</Button>
                 <Button variant="secondary" onClick ={()=>this.rechercheEtablissement('ofii')}>O.F.I.I</Button>
                 <Button variant="secondary" onClick ={()=>this.rechercheEtablissement('commissariat_police')}>Commisariat de police</Button>
                 <Button variant="secondary" onClick ={()=>this.rechercheEtablissement('gendarmerie')}>Gendarmerie</Button>
                 <Button variant="secondary" onClick ={()=>this.rechercheEtablissement('prefecture')}>Préfecture</Button>
                 <Button variant="secondary" onClick ={()=>this.rechercheEtablissement('sous_pref')}>Sous-préfecture</Button>
                 Nbre établissements: <span className="badge badge-success">{this.state.recherche.length}</span>
                
                <Row>
                    {recherche}
                </Row>
                
                <div>{pagination}</div>
            </Fragment>
        
        );
        
    }
}
export default Localisation;